import React from 'react';
import { Flex, NText } from '@fttb/common/components';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var TariffParameter = function TariffParameter(_ref) {
  var iconSrc = _ref.iconSrc,
    text = _ref.text;
  return /*#__PURE__*/React.createElement(Flex, {
    className: cn('component', 'mar-b-2xs'),
    gap: "2xs",
    "data-t-id": "components-TariffParameter"
  }, iconSrc && /*#__PURE__*/React.createElement("img", {
    alt: text,
    src: iconSrc
  }), /*#__PURE__*/React.createElement(NText, {
    size: "size6-r"
  }, text));
};